import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { getOperatorId, handleError, isProd } from '../Shared/Functions';
import ReCAPTCHA from "react-google-recaptcha";
import { UserUtilityVService, CaptchaService, $UsernameRecovery } from '../../services/V2/keymaster';
import { FormController } from '../Shared/FormController';

export function ForgotUsername({ hide, show, fail, success }) {
    const recaptchaRef: any = React.useRef();

    const [user, setUser] = useState<any>();
    const [setToken, setSetToken] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        getOperatorId()
            .then(x => setUser({
                ...user,
                operatorId: x
            }))
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const send = async () => {
        var token = setToken
        if(!setToken){
            await recaptchaRef?.current?.reset();
            token = await recaptchaRef?.current?.executeAsync();
            setSetToken(token)
        }
        CaptchaService.captchaValidate(token)
            .then(x => {
                if(x.success) {
                    setLoading(true)
                    UserUtilityVService.userUtilityVUsernameRecovery(user)
                        .then(x => {
                            success("Check your email for username.")
                            hide()
                            setLoading(false)
                        })
                        .catch(x => {
                            fail(handleError(x))
                            setLoading(false)
                            setSetToken(null)
                        })
                } else {
                    fail("An error occurred validating the reCaptcha. Please refresh the page to try again. If errors persist, please contact support.")
                    setLoading(false);
                    setSetToken(null)
                }
            })
    }

    return <>
        {user &&
            <Dialog onClose={hide} open={show}>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={isProd() ? "6LdysiEhAAAAAPZwsLD0CCf4U8yJvrD6pkuGuTHw" : "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"}
                />
                <DialogTitle>Forgot Username</DialogTitle>
                <DialogContent>
                    <FormController keys={$UsernameRecovery.properties} model={user} setModel={setUser} hiddenKeys={["operatorid"]} operatorId={user.operatorId} />
                </DialogContent>
                <DialogActions className='forgot-info-buttons-group'>
                    <Button variant="outlined" onClick={hide} style={{marginRight:"10px"}}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={send}>
                        Send
                    </Button>
                </DialogActions>
                {loading && <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div>}
            </Dialog>
        }
    </>
}
